module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av238-aa42078b2a650f07daf642f84f7cf305.jpg";